import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"text-align":"left"} }
const _hoisted_2 = {
  key: 0,
  class: "markets-form"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "За пользователем закреплены объекты:", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Пожалуйста, выберите сотрудника для переноса:", -1)
const _hoisted_5 = {
  key: 0,
  class: "selector-error"
}
const _hoisted_6 = {
  key: 1,
  class: "markets-form",
  style: {"text-align":"center"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"2rem"} }, "Подтвердите операцию", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "markets-form__footer" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Отмена")
const _hoisted_11 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiMultiSelector = _resolveComponent("UiMultiSelector")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Preloader = _resolveComponent("Preloader")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.data.title), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.data.hasObjectsToTransfer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("p", null, "Объекты торговли: " + _toDisplayString(_ctx.data.objectCounts.taxObjectsCount || 0), 1),
              _createElementVNode("p", null, "Налогоплательщики: " + _toDisplayString(_ctx.data.objectCounts.taxPayersCount || 0), 1),
              _hoisted_4,
              _createVNode(_component_UiMultiSelector, {
                style: {"width":"100%"},
                modelValue: _ctx.data.inspectors.transferId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:transferId', $event))),
                options: _ctx.data.inspectorsList
              }, null, 8, ["modelValue", "options"]),
              (_ctx.data.error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.data.error), 1))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
      ])
    ]),
    controlButtons: _withCtx(() => [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_Btn, {
          style: {"min-width":"33%"},
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }),
        _createVNode(_component_Btn, {
          type: "primary",
          size: "large",
          disabled: (_ctx.data.hasObjectsToTransfer && !Number.isInteger(_ctx.data.inspectors.transferId)) || _ctx.data.handleRequest,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('userChangesConfirmed', _ctx.data.removeInspector)))
        }, {
          default: _withCtx(() => [
            (_ctx.data.handleRequest)
              ? (_openBlock(), _createBlock(_component_Preloader, { key: 0 }))
              : (_openBlock(), _createElementBlock("span", _hoisted_11, "Подтвердить"))
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _: 1
  }))
}